import {
  CURATED_CONTENT_ACTION_STARTS,
  CURATED_CONTENT_ACTION_ERRORS,
  GET_ALL_CURATED_CONTENTS,
  GET_CURATED_CONTENT_BY_ID,
  CREATE_CURATED_CONTENT,
  UPDATE_CURATED_CONTENT,
  DELETE_CURATED_CONTENT,
} from './actions';

const initialState = {
  curatedContents: [],
  currentCuratedContent: null,
  loading: false,
  error: null,
};

const curatedContentReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case CURATED_CONTENT_ACTION_STARTS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CURATED_CONTENT_ACTION_ERRORS:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_ALL_CURATED_CONTENTS:
      return {
        ...state,
        loading: false,
        curatedContents: action.payload,
        error: null,
      };
    case GET_CURATED_CONTENT_BY_ID:
      return {
        ...state,
        loading: false,
        currentCuratedContent: action.payload,
        error: null,
      };
    case CREATE_CURATED_CONTENT:
      return {
        ...state,
        loading: false,
        curatedContents: [action.payload, ...state.curatedContents],
        error: null,
      };
    case UPDATE_CURATED_CONTENT:
      return {
        ...state,
        loading: false,
        curatedContents: state.curatedContents.map((content: any) =>
          content.id === action.payload.id ? action.payload : content
        ),
        currentCuratedContent: action.payload,
        error: null,
      };
    case DELETE_CURATED_CONTENT:
      return {
        ...state,
        loading: false,
        curatedContents: state.curatedContents.filter((content: any) => content.id !== action.payload),
        error: null,
      };
    default:
      return state;
  }
};

export default curatedContentReducer;
